import { render, staticRenderFns } from "./ScreenshotModal.vue?vue&type=template&id=23d10188&scoped=true&"
import script from "./ScreenshotModal.vue?vue&type=script&lang=js&"
export * from "./ScreenshotModal.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotModal.vue?vue&type=style&index=0&id=23d10188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d10188",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAppBar,VContainer,VDialog,VIcon})
